import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';
@Injectable()
export class DynamicFormService {
  
 
  getFormData(formId,partnerId,PartnerType) {
    return this.http.get(CommonConstants.env + 'api/patient/form/data/'+formId+'/'+partnerId+'/'+PartnerType)
  }
  
  constructor(private http: HttpClient) {
  }

  saveFormData(saveData){
    return this.http.post(CommonConstants.env +'api/patient/mySpace/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  errorHandler(error: any): void {
    throwError(error);
  };

  getMaxRowId(formId: any, partnerId: number, partnerType: number) {
    return this.http.get(CommonConstants.env + 'api/patient/form/data/rowId/'+formId+'/'+partnerId+'/'+partnerType)
  }
  getCount(partnerId: number, partnerType: number) {
    return this.http.get(CommonConstants.env + 'api/dashboard/file/count/'+partnerId+'/'+partnerType);
  }
  getMedicalFile(partnerId: number, partnerType: number) {
    return this.http.get(CommonConstants.env + 'api/dashboard/file/details/'+partnerId+'/'+partnerType);
  }
  
}
